<template>
  <div class="content">
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>基本信息</b></div>
      <el-row :gutter="24">  
         <el-col :span="7"><div class="search-area-div1">月份：{{tableData.month}}</div> </el-col> 
         <el-col :span="5"><div class="search-area-div1">批次：{{tableData.batchNum}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">提报金额(元)：{{tableData.performanceTotalAmount | numDigit | numFmt}}</div> </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">提报组织：{{tableData.organisationName}}</div> </el-col>
        <el-col :span="5"><div class="search-area-div1">提报人：{{tableData.staffName}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">提报人岗位：{{tableData.positionNames | roleNames}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="24"> 
        <el-col :span="5"><div class="search-area-div1">提报时间：{{tableData.reportTime | getDate}}</div> </el-col>   
      </el-row> 
    </div> 
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <div class=" back-color-fff mt15" style="padding: 16px;">
    <div class="w100f t-left mb15">
    <b>提报明细</b>
    </div>
      <el-table :data="tableData.performanceReportDetailVOS" border style="width: 100%;margin-top: 15px;" v-loading="tableLoading" show-summary :summary-method="getSummaries">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="人员" header-align="center"  width="150" align="center" fixed="left"></el-table-column>
        <el-table-column prop="positionNames" label="组织" header-align="center" width="150" align="center">
              <template slot-scope="scope">{{ scope.row.organisationNames | roleNames}}</template>
        </el-table-column> 
        <el-table-column prop="positionNames" label="岗位" header-align="center" width="150" align="center">
              <template slot-scope="scope">{{ scope.row.positionNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="performanceAmount" label="推广费(元)" header-align="center" width="150" align="center">
            <template slot-scope="scope">{{ scope.row.performanceAmount | numDigit | numFmt}}</template>
        </el-table-column>
        <el-table-column prop="mobileNo" label="手机号" header-align="center" width="150" align="center"></el-table-column>
        <el-table-column prop="idCode" label="身份证号" header-align="center" width="200" align="center"></el-table-column> 
        <el-table-column prop="levyCompanyName" label="推广费发放主体(代征公司)"  width="120" header-align="center" align="right"> 
        </el-table-column> 
        <el-table-column prop="insuredCompanyName" label="签约公司" header-align="center" align="center"  width="150"></el-table-column> 
        <el-table-column prop="bankAccount" label="账户" header-align="center" align="center" width="200"></el-table-column> 
        <el-table-column prop="bank" label="开户行" header-align="center" align="center"  width="200"> 
        </el-table-column> 
        <el-table-column prop="picNum" label="上报照片数(推广费月份)" width="160" header-align="center" align="right" fixed="right"></el-table-column>
        <el-table-column prop="orderNum" label="上报订单数(推广费月份)" width="160" header-align="center" align="right" fixed="right"></el-table-column>
        <el-table-column prop="visitNum" label="上报拜访次数(推广费月份)" width="160" header-align="center" align="right" fixed="right"></el-table-column>
        <el-table-column prop="orderAmount" label="上报业绩(推广费月份)" width="150" header-align="center" align="right" fixed="right">
        <template slot-scope="scope">{{ scope.row.orderAmount | numDigit | numFmt}}</template>
        </el-table-column> 
      </el-table> 
      
    </div>   
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 30, 50]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   -->

  </div>
</template>

<script>
export default {
  data() {
    return { 
      page: {
        pageIndex: 1,
        pageSize: 1000,
        totalPage: 0,
        totalRows: 0,
        performanceReportGuid: '',
      },
      tableData: [], 
      tableLoading:false
    };
  },
  created() {
    // 列表
    this.getData(false);
  }, 
  methods: { 
      getSummaries(param) {
        console.log(param);
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 5 || index === 6 || index === 7 || index === 8 || index === 9 || index === 10 || index === 11 || index === 12|| index === 13) {
            sums[index] = '';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = ' ';
          }
        });

        return sums;
      },
    getData(flg) {
      let self = this; 
      self.page.performanceReportGuid = self.$router.history.current.query.performanceReportGuid;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-report-summary-detail`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data;
          self.tableData.positionNames = self.$router.history.current.query.positionNames;
          self.tableData.month = self.$router.history.current.query.month;
          self.tableData.batchNum = self.$router.history.current.query.batchNum;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
